import { FavorableContent } from '@modules/favorites/interfaces/favorable-content.interface';
import { FavoriteDataInterface } from '@modules/favorites/interfaces/favorite-data.interface';
import { MediaImageModel } from '@modules/media/models/media-image.model';
import { MediaVideoModel } from '@modules/media/models/media-video.model';
import { MediaFactory } from '@modules/media/models/media.model';
import { TrackingItem } from '@modules/shared/gtm/data-layer.types';
import { DownloadableContent, DownloadData } from '@modules/shared/services/download.service';
import { SharableContent, SharingData } from '@modules/shared/services/share.service';
import { ButtonItem } from '@modules/ui/action-container/action-container.component';

import { CardLinkInterface } from '../interfaces/card-link.interface';
import { CardInterface } from '../interfaces/card.interface';

export class CardModel implements SharableContent, FavorableContent, DownloadableContent {
  icon?: string;
  topline?: string;
  text?: string;
  fuelLabel?: string;
  headline?: string;
  metaItems?: string[];
  translatableMetaItems?: { key: string; data: any }[];
  tags?: string[];
  metaItemsTop?: boolean;
  alignContent!: string;
  media!: MediaImageModel | MediaVideoModel;
  link?: CardLinkInterface;
  actions?: ButtonItem[]; // wont automatically add buttons to <mb-card>
  type?: string;

  favoriteData?: FavoriteDataInterface;
  shareData?: SharingData;
  downloadData?: DownloadData;
  trackingData: TrackingItem | undefined;

  constructor(data: CardInterface) {
    this.icon = data.icon;
    this.topline = data.topline;
    this.text = data.text;
    this.fuelLabel = data.fuelLabel;
    this.headline = data.headline;
    this.metaItems = data.metaItems;
    this.link = data.link;
    this.translatableMetaItems = data.translatableMetaItems;
    this.tags = data.tags;
    this.metaItemsTop = data.metaItemsTop;
    this.alignContent = (data.alignContent || '') as string;
    if (data.media) {
      this.media = MediaFactory.create(data.media) as MediaImageModel;
    }
    this.actions = data.actions;
    this.type = data.type;

    this.favoriteData = data.favoriteData;
    this.shareData = data.shareData;
    this.downloadData = data.downloadData;
    this.trackingData = data.trackingData;
  }
}
